<template>
  <div>
    <div id="CreateLogFormIssues">
    <dragAndDrop
      v-on:keyup.native.enter="SubmitLog()"
      v-on:pictureuploadstatusissues="pictureuploadstatushandler($event)"
      v-on:picture-id-issues="handlePictureid($event)"
      v-on:removePictureIdIssues="RemovePictureIdLocally($event)"
      :propertyid="this.propertyid" 
      :key="dragAndDropKey"
     >
      <div class="input-div">
        <el-input
         @keydown.native.enter.exact.prevent="SubmitLog()"
         ref="createLogForIssueInput"
          type="textarea"
          style=" resize: none;
                  width: calc(100% - 25px);
                  font-size: 18px;"
          autosize
          placeholder="Type comment here"
          v-model="form.note"
        ></el-input>
        <el-tooltip
          v-if="pictureuploadstatusissues == 0"
          class="item"
          effect="dark"
          content="Submit note"
          placement="top"
        >
          <i class="el-icon-position" style="display:inline; cursor: pointer;" @click="SubmitLog()"></i>
        </el-tooltip>
        <i v-if="pictureuploadstatusissues != 0" class="el-icon-loading"></i>

        <div class="action-board">
      <div class="file-column">

          <PictureUploadMultiIssue
            v-on:keyup.native.enter="SubmitLog()"
            v-on:pictureuploadstatusissues="pictureuploadstatushandler($event)"
            v-on:picture-id-issues="handlePictureid($event)"
            v-on:removePictureIdIssues="RemovePictureIdLocally($event)"
            :propertyid="this.propertyid"
            :key="PictureUploadKeyIssues
            "
          />
            </div>
      <div class="file-column">

          <FileUploadIssues
            v-on:keyup.native.enter="SubmitLog()"
            v-on:logtype="handlelogtype()"
            v-on:file-id="handleFileid($event)"
            v-on:fileuploadstatus="fileuploadstatushandler($event)"
            v-on:removeFileId="RemoveFileIdLocally($event)"
            :propertyid="this.propertyid"
            :key="FileUploadKeyIssues
            "
          />
      </div>
                <div class="file-column">

           <dragAndDropHolder
                 :key="dropHolderKey"
                  v-on:removePictureIdIssues="RemovePictureIdLocally($event)"
           >

           </dragAndDropHolder>

                </div>
        </div>
      </div>
    </dragAndDrop>

    </div>
  </div>
</template>

<script>
import EventService from "@/services/EventService.js";
import PictureUploadMultiIssue from "@/components/utilities/PictureUploadMultiIssue.vue";
import dragAndDrop from "@/components/utilities/dragAndDrop.vue";
import dragAndDropHolder from "@/components/utilities/dragAndDropHolder.vue";
import FileUploadIssues from "@/components/utilities/FileUploadIssues.vue";
import { mapState } from "vuex";
export default {
  props: {
    currentissueid: String,
    propertyid: String
  },
  components: {
    PictureUploadMultiIssue,
    FileUploadIssues,
    dragAndDrop,
    dragAndDropHolder
  },
  data() {
    return {
      pictureuploadstatusissues: 0,
      fileuploadstatus: 0,
      form: {
        // issuetitle: "",
        logtype: 0,
        userassigned: [],
        propertyid: this.propertyid,
        machineid: this.$route.params.MachineId,
        userid: "",
        userspicurl: "",
        note: null,
        files: [],
        pictureid: [],
        issueid: this.currentissueid,
        imageurl: []
      },
      FileUploadKeyIssues: 100,
      PictureUploadKeyIssues: 200,
      dragAndDropKey:300,
      dropHolderKey: 400,
      submitPressed: false,     
      // savedNoteText: null,
      // pictureName: null,
      // fileName: null, 
      // savedPictureName: null,
      // savedFileName: null
    };
  },
  created() {
    this.form.userid = this.user.userid;
  },
  mounted(){
    this.$refs.createLogForIssueInput.focus(); 
  },
  computed: {
    ...mapState({
      user: state => state.user.user
    })
  },
  watch: {
    pictureuploadstatusissues: {
      
        handler: function(newVal, oldVal){
            if(newVal == 0 && this.submitPressed == true){
            this.SubmitLog()
            }
        },
    },
      fileuploadstatus: {
        handler: function(newVal, oldVal){
          console.log(newVal)
            if(newVal == 0 && this.submitPressed == true){
               this.submitPressed = false;
            this.SubmitLog()
            }
        },
    },
  },
  methods: {
    handlePictureid($event) {
      // for (const object of $event) {
            this.form.pictureid.push($event[0].pictureid);
      this.pictureName = $event[1].imageinformation[0].filename;
      // }
    },
    handlelogtype() {
      this.form.logtype = 1;
    },
    handleFileid($event) {
     
     this.form.files.push({ fileid: $event[0].fileid });
     this.fileName = $event[1].fileinformation[0].filename;
    },
    RemovePictureIdLocally(img) {
      this.$delete(this.form.pictureid, this.form.pictureid.indexOf(img));
    },
    RemoveFileIdLocally(fileid) {
      for (let fileidobjects of this.form.files) {
        if (fileid == fileidobjects.fileid)
          this.$delete(this.form.files, this.form.files.indexOf(fileidobjects));
      }
    },
    SubmitLog() {

      if(this.pictureuploadstatusissues == 1 || this.fileuploadstatus == 1){
        //picture status is still uploading, so submitting is kept back, and is automatically called 
        //from watcher when finished uploading
        this.submitPressed = true;
        return
      }

      if(this.form.note == null && this.form.pictureid.length == 0 && this.form.files.length == 0){
        return;
      }

      // if(this.savedNoteText != null || this.savedPictureName != null || this.savedFileName != null){

      //  if(this.form.note == this.savedNoteText  && this.pictureName == this.savedPictureName  && this.fileName == this.savedFileName){
      //         this.$store.dispatch("addNotification", {
      //           type: "failure",
      //           Message: "Note already submitted"
      //         });
      //         return
      //   }
        
      //   }
      //     this.savedNoteText = JSON.parse(JSON.stringify(this.form.note));
      //     this.savedPictureName = JSON.parse(JSON.stringify(this.pictureName))
      //     this.savedFileName = JSON.parse(JSON.stringify(this.fileName));

      //     this.pictureName = null
      //     this.fileName = null
        

      //the $options gets the form data non-reactive, so this form data doesn't get cleared before submit
        this.$options.staticFormForSubmit = this.form;

      //the $options makes non-reactive so the form doesn't get all this added fields
        this.$options.staticFormForUpdate = this.form;

        this.$options.staticFormForUpdate.firstname = this.user.firstname;
        this.$options.staticFormForUpdate.lastname = this.user.lastname
        this.$options.staticFormForUpdate.logdate = new Date();
        this.$options.staticFormForUpdate.userspicurl = this.user.imageurl;


        this.$emit("add-log-locally", this.$options.staticFormForUpdate);

         this.clearForm();

  

      EventService.addLog(this.$options.staticFormForSubmit)
        .then(response => {

         let updatelogpackage = [this.$options.staticFormForUpdate, response.data];

          this.$emit("local-log-return-data", updatelogpackage);
          
          // this picture upload key forces the component to rerender thereby removing the image upload preview
          this.FileUploadKeyIssues++;
          this.PictureUploadKeyIssues++;
          this.dragAndDropKey++;

          this.$nextTick(function () {
            this.$refs.createLogForIssueInput.focus(); 
          })
        })
        .catch(error => {
            console.log(error);
        });
    },
    clearForm() {
      this.form = {
        // issuetitle: "",
        logtype: 0,
        userassigned: [],
        propertyid: this.propertyid,
        machineid: this.$route.params.MachineId,
        userid: this.user.userid,
        userspicurl: "",
        note: null,
        files: [],
        pictureid: [],
        issueid: this.currentissueid,
        imageurl: []
      };
    },
    pictureuploadstatushandler($event) {
      this.pictureuploadstatusissues = $event;
    },
   fileuploadstatushandler: function($event){
      this.fileuploadstatus = $event;
    }
  }
};
</script>

<style scoped>
.input-div {
  border: 1px solid gray;
  bottom: 0px;
  margin: 0% 2%;
  background-color: white;
  border-radius: 5px;
}

input :focus {
  border: none;
}
.action-board{
  display: flex;
}

.file-column{
  max-height: 50vh;
  overflow: auto;
  padding: 7px 10px;
}

@media (min-width: 250px) and (max-width: 979px) {
  .input-div {
    width: 93vw;
    margin: auto;
  }
    .file-column{
    padding: unset;
  }
}
</style>
